import { Enum, EnumType } from 'ts-jenum';

@Enum<BrickLocationType>('value')
export class BrickLocationType extends EnumType<BrickLocationType>() {
   static readonly BOTH = new BrickLocationType(0);
   static readonly BRICKWALL = new BrickLocationType(1);
   static readonly PILOTPANEL = new BrickLocationType(2);

   private constructor(public value: number) {
      super();
   }
}
